var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-avatar-filled-alt",
    transform: "translate(-2.25 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43926",
    "data-name": "Path 43926",
    d: "M9.75,2.25a7.5,7.5,0,1,0,7.5,7.5A7.5,7.5,0,0,0,9.75,2.25Zm4.286,12.278V14.2a2.79,2.79,0,0,0-2.679-2.845H8.143A2.786,2.786,0,0,0,5.47,14.2c0,.006-.005.012-.005.018v.313a6.431,6.431,0,1,1,8.571-.005Z",
    fill: "#505f7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43927",
    "data-name": "Path 43927",
    d: "M15.188,7.875A2.813,2.813,0,1,0,18,10.688a2.813,2.813,0,0,0-2.812-2.813Z",
    transform: "translate(-5.437 -3.021)",
    fill: "#505f7b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user-avatar.22afa50b.svg";
export { ForwardRef as ReactComponent };